import { render, staticRenderFns } from "./AddPptResource.vue?vue&type=template&id=a6e604ba&scoped=true"
import script from "./AddPptResource.vue?vue&type=script&lang=js"
export * from "./AddPptResource.vue?vue&type=script&lang=js"
import style0 from "./AddPptResource.vue?vue&type=style&index=0&id=a6e604ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e604ba",
  null
  
)

export default component.exports